<template>
  <nav class="navbar">
    <div class="container">
      <div class="navbar-brand">
        <a href="/" class="name">Kevin Chen</a>
        <a
          role="button"
          class="navbar-burger"
          :class="{ 'is-active': navBurgerActive }"
          aria-label="menu"
          aria-expanded="false"
          @click="navBurgerActive = !navBurgerActive"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <!-- ./navbar-brand -->
      <div class="navbar-menu" :class="{ 'is-active': navBurgerActive }">
        <div class="navbar-end">
          <div class="navbar-item">
            <router-link to="/client-showcase" active-class="active"
              >Client Showcase</router-link
            >
          </div>
          <!-- ./navbar-item -->
          <div class="navbar-item">
            <router-link to="/places" active-class="active">Places</router-link>
          </div>
          <!-- ./navbar-item -->
          <div class="navbar-item">
            <router-link to="/contact" active-class="active"
              >Contact</router-link
            >
          </div>
          <!-- ./navbar-item -->
        </div>
        <!-- ./navbar-end -->
      </div>
      <!-- ./navbar-menu -->
    </div>
    <!-- ./container -->
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      navBurgerActive: false
    }
  }
}
</script>
